import React,{useMemo} from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useTable,useRowSelect } from 'react-table';
import {MakeExcelFileForDownload,CloseExcelPopup,IndeterminateCheckbox,addThousandPoint,ResetMonthString,GetShotDateString} from "../../../components/common/Common";
import removeIcon from "../../../img/icon/icon-circle-minus.svg";

const SettlementSearchResult = ({varTotalState,varColumnLists,varSearchData,varSettlementLists,varTotalData}) => {

  //컬럼 - 제목부
  const columns = useMemo(() => {
    return varColumnLists; 
    // eslint-disable-next-line
  },[varColumnLists]);

  //표시할 정보
  const data = useMemo(() => {
    return varSettlementLists;
    // eslint-disable-next-line
  }, [varSettlementLists]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow,selectedFlatRows} 
    = useTable({ columns, data, initialState:{hiddenColumns:["st_idx","st_terms"]}},useRowSelect, 
      hooks => {
        hooks.visibleColumns.push(columns => [
          {
            id: 'selection',
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <div style={{width:"20px"}}>
                <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
              </div>
            ),
            Cell: ({ row }) => (
              <div style={{width:"40px"}}>
                <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
              </div>
            )
          },
          ...columns,
        ])
      }
  );

  //엑셀 다운로드--------------------------------------------------------
  //엑셀다운 범위 선택창 표시
  const onSelectDownloadModeHandler = (e) => {
    const popupWin = document.querySelector('.excel-buttons');
    if(popupWin.classList.contains('hide')) popupWin.classList.remove('hide');
  }
  //엑셀로 다운로드 방식 선택후
  const onDownloadExcelHandler = (e,imode) => {
    var iselected = selectedFlatRows.length;
    console.log(iselected);
    const popupWin = document.querySelector('.excel-buttons');
    if(!popupWin.classList.contains('hide')) popupWin.classList.add('hide');
    if(imode === 1) MakeExcelFileForDownload(varColumnLists,varSettlementLists,'정산 현황');
    else ReadAllLists();
  } 
  //전체페이지 정보 읽기
  const ReadAllLists = async() => {
    const sendData = {pageNum: 0,pageSize: 0,searchData: varSearchData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_settlement_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        let newArray = [];
        const pmax = datas.totals[0].tcount;
        if(datas.results?.length > 0) {
          const dataArray = datas.results;
          for(var i=0; i < dataArray.length; i++) {
            const lineObj = dataArray[i];
            var newData = {};
            newData['nums'] = pmax - i;
            newData['bh_company'] = lineObj.bh_company;
            newData['speriod'] = lineObj.st_year + '.' + lineObj.st_month;
            newData['st_rdate'] = GetShotDateString(lineObj.st_rdate);
            newData['st_state'] = lineObj.st_status===1?"승인대기":lineObj.st_status===2?"승인완료":"정산완료";
            newData['m_ry_name'] = lineObj.m_ry_name;
            newData['m_childrens'] = lineObj.m_childrens;
            newData['m_amount'] = addThousandPoint(lineObj.m_amount);
            newData['f_ry_name'] = lineObj.f_ry_name;
            newData['f_childrens'] = lineObj.f_childrens;
            newData['f_amount'] = addThousandPoint(lineObj.f_amount);
            newData['t_amount'] = addThousandPoint(lineObj.m_amount + lineObj.f_amount);
            newData['t_childrens'] = lineObj.m_childrens + lineObj.f_childrens;
            newData['s_amount'] = addThousandPoint(lineObj.s_amount);
            newData['total_amount'] = addThousandPoint(lineObj.m_amount + lineObj.f_amount + lineObj.s_amount);
            newData['st_income'] = addThousandPoint(lineObj.st_income);
            newData['st_fdate'] = lineObj.st_status===1?null:GetShotDateString(lineObj.st_fdate);
            newData['st_idx'] = lineObj.st_idx;

            newArray.push(newData);
          }
        }
        MakeExcelFileForDownload(varColumnLists,newArray,'정산 현황');
      }
    });
  }
  return (
    <div className="main-box" style={{marginTop:"30px",padding:"0px 10px"}}>
      <div style={{display:"flex",justifyContent:"space-between"}}>
        <div className="search-area" style={{width:"70%",padding:"10px 20px",lineHeight:"normal",alignItems:"center"}}>
          <div>{`센터 : ${varTotalData.branch}`}</div> &nbsp;&nbsp;&nbsp;&nbsp;
          <div>기간&nbsp;&nbsp;:&nbsp;&nbsp;
            {varSearchData.searchYear===0?"없음":`${varSearchData.searchYear}년`}&nbsp;&nbsp;
            {varSearchData.searchMonth>0?varSearchData.searchMonth+"월":null} 
          </div>&nbsp;&nbsp;&nbsp;
          <div>{`정산 총액 : ${addThousandPoint(varTotalState.totalamount)}원`}</div>
          {varSettlementLists.length===0?null:
            <div className="excel-area">
              <button onClick={e=>onSelectDownloadModeHandler(e)} className="btn line">엑셀다운로드</button>
              <div className="excel-buttons hide">
                <button onClick={e=>onDownloadExcelHandler(e,1)}>현재페이지</button>
                <button onClick={e=>onDownloadExcelHandler(e,0)}>전체</button>
                <img src={removeIcon} alt="" className="excel-close-button" onClick={()=>CloseExcelPopup()}/>
              </div>
            </div>
          }
        </div>
        <div className="search-string" style={{width:"30%",display:"flex",justifyContent:"right",paddingRight:"0px"}}>
          <div><label htmlFor="tcount">검색건수</label>&nbsp;<span id="tcount">{varTotalState.totalcount}</span>&nbsp;건</div>&nbsp;&nbsp;&nbsp;
          <Link to={`/Admin/SettlementDetail/0/${`${varSearchData.searchYear}-${ResetMonthString(varSearchData.searchMonth)}`}`} style={{width:"120px"}} className="btn line">정산 요청서</Link>
        </div>
      </div>
      <div className="scroll-table" style={{border:"solid 1px #ccc",marginBottom:"10px"}}>
        <table className="list scroll delivery" {...getTableProps()}>
          {varColumnLists?.length===0?<thead></thead>:
            <thead>
              {headerGroups.map((headerGroup) => {
                const { key, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
                return (
                  <tr key={key} {...restHeaderGroupProps}>
                    {headerGroup.headers.map((column,ii) => {
                      const { key, ...restColumn } = column.getHeaderProps({style:{width:ii===0?40:column.width}});
                      return (<th key={key} {...restColumn}>{column.render('Header')}</th>);
                    })}
                    <th style={{width:"90px"}}>상세</th>
                  </tr>
                )
              })}
            </thead>
          }
          {varSettlementLists?.length===0?<tbody><tr><td colSpan={11}>등록된 정산 내역이 없습니다.</td></tr></tbody>:
            <tbody {...getTableBodyProps()}>
              {rows.map((row,i) => {
                prepareRow(row);
                const { key, ...restRowGroupProps } = row.getRowProps();
                return (
                  <tr key={key} {...restRowGroupProps}>
                    {row.cells.map((cell,i) => {
                      const { key, ...restCellProps } = cell.getCellProps();
                      return (<td key={key} {...restCellProps}>{cell.render('Cell')}</td>);
                    })}
                    <td>
                      <Link to={`/Admin/SettlementDetail/${row.values.st_idx}/${row.values.st_terms}`} style={{width:"80px"}} className="btn line black">상세</Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          }
        </table>
      </div>
    </div>
  )
}
export default SettlementSearchResult;